export enum TagSeverity {
  SUCCESS = 'success',
  INFO = 'info',
  WARN = 'warn',
  DANGER = 'danger',
  SECONDARY = 'secondary',
  CONTRAST = 'contrast',
}
